<template>

<scroll-container class="site section" :class="scrollClasses" :data-page="page" @change="updateMonitorState">
  <Navigation :scrollPosition="scrollPosition" />
  <main>
    <slot :scrollPosition="scrollPosition" :window="window" :monitorState="monitorState" />
  </main>
  <Footer />
  <!-- <debug_windowDimensions :window="window" /> -->
</scroll-container>
</template>

<script>
import Footer from '@/layouts/includes/footer';
import Navigation from '@/layouts/includes/navigation';

import throttle from 'lodash/throttle';

export default {
  components: { Footer, Navigation },

  props: ['data', 'page', 'section'],

  data() {
    return {
      scrollPosition: 0,
      window: {
        width: 0,
        height: 0,
      },
      monitorState: {},
    };
  },

  computed: {
    scrollClasses() {
      const classes = {};
      const key = this.section || 'default';
      const keyName = `section-${key}`;
      classes[keyName] = true;
      return classes;
    },
  },

  methods: {

    updateMonitorState (state) {
      this.monitorState = state;
    },

    updateScrollState (scrollState) {
      this.$store.commit('updateScrollState', scrollState);
    },

    onScroll() {
      const prev = this.scrollPosition;
      const current = this.getScrollPosition();

      const direction = current > prev ? 'down' : 'up';

      this.scrollPosition = current;
      if (direction !== this.$store.state.scrollDirection) {
        this.$store.commit('updateScrollDirection', direction);
      }
    },

    getScrollPosition() {
      return window.pageYOffset || document.documentElement.scrollTop;
    },

    onResize() {
      this.updateWindowDimensions();
    },

    updateWindowDimensions() {
      const width = window.innerWidth;
      const height = window.innerHeight;
      this.$set(this.window, 'width', width);
      this.$set(this.window, 'height', height);
      const windowDimensions = {
        width, height,
      };
      this.$store.commit('updateWindowDimensions', windowDimensions);
      // DEBUG
      // console.log('resize', width, height);
    },

  },

  mounted() {
    this.onScroll();
    this.updateWindowDimensions();

    this.handleOnScroll = throttle(this.onScroll, 10);
    this.handleonResize = throttle(this.onResize, 50);
    window.addEventListener('scroll', this.handleOnScroll);
    window.addEventListener('resize', this.handleonResize);
    // DEBUG
    // console.log(`showing page: ${this.page}`);
    /*
    window.addEventListener('orientationchange', function() {
      const angle = screen.orientation.angle;
      // DEBUG
      // console.log(`the orientation of the device is now: ${angle}`);
    });
    */
  },

  beforeDestroy: function() {
    window.removeEventListener('scroll', this.handleOnScroll);
    window.removeEventListener('resize', this.handleonResize);
  },

};
</script>

<style lang="scss">
@import '../styles/main.scss';
@import '../styles/_typography.scss';
@import '../styles/_mixins.scss';

.site {
  footer {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr $layout--content-gutter-width $layout--max-content-container-width $layout--content-gutter-width 1fr;

    & > [data-module] {
      grid-column: 3 / span 1;

      &.stretch {
        grid-column: 2 / span 3;
      }

      &.constrain {
        margin: 0 ($layout--gutter * 2);
      }
    }

    @include mq($layout--max-width, down) {
      grid-template-columns: 0 1fr $layout--max-content-container-width 1fr 0;
    }

    @include mq($layout--max-content-container-width, down) {
      grid-template-columns: 0 0 100% 0 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/default.vue